import { JWT_LOCAL_STORAGE_KEY } from '@src/contexts/user-context'
import axios, { AxiosError } from 'axios'
import initializeMsal, { protectedResources } from './Authentification'
import { reportErrorToConsole } from './error-logger'

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

let isRedirecting = false

const redirectToLogin = () => {
  if (isRedirecting) return
  isRedirecting = true

  localStorage.removeItem(JWT_LOCAL_STORAGE_KEY)
  const msalInstance = initializeMsal()
  msalInstance
    .loginRedirect({ scopes: protectedResources.getTokenAzure.scopes.read })
    .catch(reportErrorToConsole)
}

// Response interceptor: Handle 401 from server
instance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      redirectToLogin()
    }
    return Promise.reject(error)
  },
)

export { instance as apiClient }
